import { addQuery } from '~/shared/routes'

/**
 * Same-origin branding paths served from Era `data/files` (stable URLs).
 * External session logos (WBS CDN) must not get `?dv=`.
 */
const BRANDING_PATH =
  /^\/(?:img\/|favicon\.ico$|icon\.svg$|apple-touch-icon\.png$|icon-192\.png$|icon-512\.png$|manifest\.webmanifest$)/

function isBrandingPath(pathname: string): boolean {
  return BRANDING_PATH.test(pathname)
}

/**
 * Append `?dv=<dataVersion>` to same-origin branding asset URLs so CDN / SW /
 * browser caches invalidate after a data snapshot change. Leaves external URLs
 * and non-branding paths unchanged. No-op when version is empty (local/dev).
 */
export function withBrandingAssetVersion(url: string, version: string): string {
  if (!url || !version) return url

  // Protocol-relative or absolute external URLs stay untouched.
  if (url.startsWith('//')) return url

  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url)
      if (parsed.origin !== window.location.origin) return url
      if (!isBrandingPath(parsed.pathname)) return url
      return addQuery(url, { dv: version })
    } catch {
      return url
    }
  }

  const pathOnly = url.split(/[?#]/, 1)[0] ?? ''
  if (!isBrandingPath(pathOnly)) return url

  return addQuery(url, { dv: version })
}
